/** @format */

import React from 'react';
import styled, { keyframes } from 'styled-components';

// Define the spin animation
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const spinnerIcon = (props: React.HTMLAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

export const Spinner = styled(spinnerIcon)`
  width: 0.875rem;
  height: 0.875rem;
  line-height: 1.25rem;
  animation: ${spin} 1s linear infinite;
`;
